import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BaseGetProvider } from "@tendercuts/http";
import { TcutsCity } from "@tendercuts/models";

@Injectable({
  providedIn: "root",
})
export class TcutsCityService extends BaseGetProvider<TcutsCity> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint
  ) {
    super(http);
    this.delegate = this;
  }

  get isCachable(): boolean {
    return false;
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  preProcessResponse(data: any): Array<any> {
    return data.results;
  }

  get model(): typeof TcutsCity {
    return TcutsCity;
  }

  get endpoint(): string {
    return this.endpointService.fetchCityList();
  }
}
